export default function(app) {
  app.config.globalProperties.$AccessControl = {
    cannot: (profile, action) => {
      switch (profile) {
      case "professional_leader":
        return [
          "export_patient_data"].indexOf(action.toLowerCase()) != -1;

      case "professional_default":
        return [
          "export_patient_data"].indexOf(action.toLowerCase()) != -1;
      }
    }
  };
}
